<!-- <p>target-people-list works!</p> -->
<p-table [value]="value()">
  <ng-template pTemplate="caption">
        <div class="flex">
          <div class="ml-auto">
            <app-resource-button-group
              [resource]="resource()"
              [saveButton]="access()?.queue_alert?.actions?.update"
              [(loading)]="loading"
              (submit)="sumit()"
              ></app-resource-button-group>
          </div>
        </div>
    </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pSortableColumn="contact">
        Contacto <p-sortIcon field="contact" />
      </th>
      <th pSortableColumn="provider">
        Proveedor <p-sortIcon field="provider" />
      </th>
      <th class="action">Acciones</th>
    </tr>
    <tr>
      <th>
        <p-columnFilter
          type="text"
          field="contact"
          placeholder="Contacto"
          ariaLabel="Filter Contact"
        />
      </th>
      <th>
        <p-columnFilter field="provider" matchMode="equals" [showMenu]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown 
                             [ngModel]="value" 
                            [options]="providerTypeArray"
                            (onChange)="filter($event.value)" 
                            placeholder="Select One" 
                            [showClear]="true"
                                [style]="{'width':'100%'}" />
                    </ng-template>
                </p-columnFilter>
        <!-- <p-columnFilter
          type="text"
          field="provider"
          placeholder="Proveedor"
          ariaLabel="Filter Provider"
        /> -->
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-value>
    <tr>
      <td [pEditableColumn]="value.contact" pEditableColumnField="contact">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input 
                                pInputText 
                                type="text" 
                                [(ngModel)]="value.contact" />
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ value.contact }}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td [pEditableColumn]="value.provider" pEditableColumnField="provider">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-dropdown 
                                [options]="providerTypeArray" 
                                appendTo="body" 
                                [(ngModel)]="value.provider" 
                                [style]="{'width':'100%'}" />
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{ value.formattedProvider }}
                        </ng-template>
                    </p-cellEditor>
                </td>
      <!-- <td>{{ value.formattedContact }}</td> -->
      <!-- <td>{{ value.formattedProvider }}</td> -->
      <td>
        <div>
          <app-resource-button-group
            [resource]="resource()"
            [resourceId]="value._id"
            [detailsButton]="true"
            [editButton]="access()?.queue_alert?.actions?.update"
            [deleteButton]="access()?.queue_alert?.actions?.delete"
            [iconOnly]="true"
            
          >
          </app-resource-button-group>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
